
import { Vue, Component, Prop } from 'vue-property-decorator';
import { InputNumberSize } from 'element-ui/types/input-number';
// import { Line } from 'vue-chartjs';
const Line = require('vue-chartjs').Line;
import { Grades, PointsData } from '@/modules/recordView';
import { GradesTypes, getGradesTypeName } from '@/enums/gradesTypes';

export interface ChartData {
  type: GradesTypes;
  subjects: LineItem[];
  times: LineItem[];
  records: SubjectRecord[];
}

export interface LineItem {
  id: string;
  name: string | string[];
  color: string;
}

export interface SubjectRecord {
  subjectId: string;
  records: TimesRecord[];
}

interface TimesRecord {
  timesId: string;
  score: number | undefined;
}

@Component({
  extends: Line
})
export default class RecordChart extends Vue {
  // display: none; の際に高さが0になるので、cssではなくこれで指定
  @Prop({ default: '400px' }) private height: string;

  private options = {
    layout: {
        padding: {
            left: 0,
            right: 15,
            top: 0,
            bottom: 0
        }
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 100,
          stepSize: 10
        },
        gridLines: {
          display: true
        }
      }],
      xAxes: [{
        gridLines: {
          display: false
        },
        ticks: {
          autoSkip: false,
          minRotation: 30,
        }
      }]
    },
    legend: {
      display: true
    },
    responsive: true,
    maintainAspectRatio: false
  };

  public viewChart(data: ChartData) {
    const ticks = this.options.scales.yAxes[0].ticks;
    switch (data.type) {
      case GradesTypes.RoutineTest:
        ticks.max = 100;
        ticks.stepSize = 10;
        break;
      case GradesTypes.OtherTest:
        ticks.max = 100;
        ticks.stepSize = 10;
        break;
      default: // case GradesTypes.Report:
        ticks.max = 5;
        ticks.stepSize = 1;
        break;
    }
    const scoreList = data.records.reduce((list, subjectRecord) => {
      list.push(...subjectRecord.records.map((record) => !record.score ? 0 : record.score));
      return list;
    }, [ticks.max]);
    ticks.max = Math.max(...scoreList);

    if (ticks.max <= 5) {
      ticks.stepSize = 1;
    } else if (ticks.max <= 10) {
      ticks.max = 10;
      ticks.stepSize = 1;
    } else if (ticks.max <= 50) {
      ticks.stepSize = 5;
    } else if (ticks.max <= 100) {
      ticks.stepSize = 10;
    } else if (ticks.max <= 200) {
      ticks.stepSize = 20;
    } else if (ticks.max <= 500) {
      ticks.stepSize = 50;
    } else {
      ticks.stepSize = 100;
    }
    if (ticks.max % ticks.stepSize > 0) {
      ticks.max = (Math.floor(ticks.max / ticks.stepSize) + 1) * ticks.stepSize;
    }

    const dataLabels = new Array<string | string[]>();
    data.times.forEach((item) => {
      dataLabels.push(item.name);
    });

    const dataList = new Array();
    data.subjects.forEach((subject) => {
      const subjectId = subject.id;
      const subjectRecord = data.records.find((item) => {
        return item.subjectId === subjectId;
      });

      const protData = new Array<number | undefined>();
      if (!!subjectRecord && !!subjectRecord.records) {
        data.times.forEach((timesItem) => {
          const timesId = timesItem.id;
          const record = subjectRecord.records.find((recordItem) => {
            return recordItem.timesId === timesId;
          });
          if (!!record) {
            protData.push(record.score);
          } else {
            protData.push(undefined);
          }
        });
      }
      const color = !subject.color ? 'black' : subject.color;
      const dataInfo = {
        label: subject.name,
        backgroundColor: color,
        pointBackgroundColor: 'white',
        borderWidth: 2,
        borderColor: color,
        lineTension: 0,
        fill: false,
        spanGaps: true,
        pointBorderColor: color,
        data: protData
      };
      dataList.push(dataInfo);
    });

    const datacollection = {
      labels: dataLabels,
      datasets: dataList,
    };
    this.$el.getElementsByTagName('canvas')[0].style.height = this.height;
    if (this.$data._chart) {
        this.$data._chart.destroy();
    }
    (this as any).renderChart(datacollection, this.options);
  }

}
